/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { RadioGroup } from '@atlaskit/radio';
import { OptionsPropType } from '@atlaskit/radio/types';
import { FormattedMessage } from '../i18n';
import { Field } from './index';

type Props = React.ComponentProps<typeof Field> & {
  options: OptionsPropType;
};

const RadioGroupField: React.FC<Props> = (props) => {
  return (
    <Field<any>
      {...props}
    >
      {({ input }) => (
        <div
          css={css`
            display: flex;
            justify-content: space-between;
          `}
        >
          <div
            css={css`
              div {display: flex;
              margin-left: -5px;
              }
              label *{
                cursor: pointer;
              }
            `}
          >
            <RadioGroup options={props.options} {...input} />
          </div>
        </div>
      )}
    </Field>
  );
};

export default RadioGroupField;
